import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import Header from "./components/Header.js";
import AddProduct from "./components/AddProduct.js";
import ListProducts from "./components/ListProducts.js";
import Home from "./components/Home.js";
import Footer from "./components/Footer";

function App() {
    return (
        <Router>
            <div className = "app-settings">
                <Header />
                <Routes>
                    <Route 
                        exact path = "/"
                        element = {<Home />}
                    />

                    <Route 
                        exact path = "/addProduct"
                        element = {<AddProduct />}
                    />

                    <Route 
                        exact path = "/listProducts"
                        element = {<ListProducts />}
                    />

                    <Route 
                        path = "*"
                        element = {<Navigate to="/" replace />}
                    />
                </Routes>
                <Footer />
            </div>
        </Router>
  );
}

export default App;
